/* global axios */
import ApiClient from "../ApiClient";
import { getTimeOffset } from "helpers/DateHelper";

class ConversionFunnelReportsAPI extends ApiClient {
  constructor() {
    super("reports/conversion_funnel", {
      accountScoped: true,
      apiVersion: "v2",
    });
  }

  getSummary({
    since,
    until,
    agentId,
    teamId,
    currency,
    granularity,
    labelId,
    labelOperator,
    datePreset,
  } = {}) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        agent_id: agentId || undefined,
        team_id: teamId || undefined,
        currency: currency || undefined,
        granularity: granularity || undefined,
        // FORK: filtro por etiqueta (cualquier scope) + operador contiene/no contiene
        label_id: labelId || undefined,
        label_operator: labelId ? labelOperator || "contains" : undefined,
        // FORK: preset de calendario (current_week | current_month). Hace que el backend
        // compare contra el mismo tramo transcurrido del mes/semana anterior.
        date_preset: datePreset || undefined,
        // FORK: alinea el agrupamiento por día con la zona del navegador (antes: siempre UTC).
        timezone_offset: getTimeOffset(),
      },
    });
  }
}

export default new ConversionFunnelReportsAPI();
